import { useTranslation } from "react-i18next";
import { useRequestMedicinesReceipt } from "src/hooks/useRequestMedicinesReceipt";
import ReceiptTable from "src/component/ReceiptTable/ReceiptTable";
import BillSection from "./BillSection";
import FakeDecisionQuestions from "./FakeDecisionQuestions";
import HeaderSection from "./HeaderSection";
import UserInfoSection from "./UserInfoSection";

import "./style.css";

const PrintableRequestTable = ({ data, isNeedCooling = false }) => {
    const { t } = useTranslation();

    const { hasCoolingMedicines, medicines, showBillSections, shouldSplitCoolingMedicinesToSeparateReceipt } = useRequestMedicinesReceipt(data, isNeedCooling)

    if (!data) return null;

    if (medicines?.length === 0 || (!shouldSplitCoolingMedicinesToSeparateReceipt && isNeedCooling)) return null;

    const totalPrice = medicines?.reduce((acc, med) => acc + (Number(med.totalPrice) || 0), 0);
    const baseColumns = [
        {
            key: "name",
            label: "medicine-name",
            className: "col",
            render: (medicine) => (
                <div className="medicine-cell">
                    {medicine.isNeedCooling && (
                        <img
                            src="/images/CoolingIcon.svg"
                            alt="Cooling required"
                            width={20}
                            height={20}
                        />
                    )}
                    <span className="medicine-name fw-bold">{medicine.name}</span>
                </div>
            )
        },
        {
            key: "mainMedicineName",
            label: "MedicinePlacement",
            className: "col-2",
            render: (m) => m.mainMedicineName || "-"
        },
        {
            key: "dose",
            label: "DoseNumber",
            className: "col-2",
            render: (m) => `${m.dosePerDay} ${m.doseType || ""}`
        },
        {
            key: "amount",
            label: "AmountNumber",
            className: "col-1",
            render: (m) => m.amount
        },
    ];

    if (data?.isFakeDecision) {
        baseColumns.push({
            key: "isModel56",
            label: "isModel56Print",
            className: "col-1",
            render: (m) => (m?.isModel56 ? "sent" : "-")
        });
    }

    if (data?.displayMedicinesPrice) {
        baseColumns.push(
            {
                key: "price",
                label: "requestPrintUnitPrice",
                className: "col-1",
                render: (m) => Number(m.unitPrice).toFixed(2)
            },
            {
                key: "totalPrice",
                label: "total",
                className: "col-1",
                render: (m) => m.totalPrice
            }
        );
    }

    return (
        <div className="px-2">
            <HeaderSection
                data={data}
                hasCoolingMedicines={hasCoolingMedicines}
                isNeedCooling={isNeedCooling}
                shouldSplitCoolingMedicinesToSeparateReceipt={shouldSplitCoolingMedicinesToSeparateReceipt}
            />
            <UserInfoSection data={data} />

            <ReceiptTable columns={baseColumns} data={medicines} >
                {data?.displayMedicinesPrice && (
                    <div className="table-row fw-bold row m-0">
                        <div className={`table-cell text-center col-11`}>
                            {t("total")}
                        </div>
                        <div className="table-cell col-1">{Number.isInteger(totalPrice) ? totalPrice : totalPrice.toFixed(2)}</div>
                    </div>
                )}
            </ReceiptTable>

            {showBillSections && data?.isFakeDecision && (<FakeDecisionQuestions data={data} />)}

            {showBillSections && <BillSection data={data} />}

            {data?.nextMonthDeliveryDate && (
                <p className="text-center fs-2 py-3 fw-bold">
                    {t("nextMonthDeliveryDateWarning")}: {data?.nextMonthDeliveryDate}
                </p>
            )}
            {data.customerSupportPhone && <p className="text-center fs-3 py-3 fw-bold">
                {t("customerSupportPhone")}:{data.customerSupportPhone}
            </p>}

        </div>
    );
}

export default PrintableRequestTable;
